import SelectOption from '@@types/SelectOption';

import { action, computed, observable } from 'mobx';

class MailDomainStore {
  @observable
  domainList: string[] = [];

  @action
  setDomainList = (domainList: string[]) => {
    this.domainList = domainList;
  };

  @computed
  get domainSelectOptionList(): SelectOption[] {
    return this.domainList.map((domain) => ({ label: domain, value: domain }));
  }
}

export default MailDomainStore;

export const mailDomainStore = new MailDomainStore();
